import { useLang } from "@/context/LanguageContext";
import { Mountain, MapPin } from "lucide-react";

export default function Footer() {
  const { t } = useLang();

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer data-testid="footer" className="bg-[#0A0A0A] border-t border-[#262626] py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <Mountain className="w-6 h-6 text-[#FF3B30]" />
              <span className="font-heading text-xl tracking-[0.15em] text-white">
                LNMA
              </span>
            </div>
            <p className="text-sm text-[#A3A3A3] font-body leading-relaxed">
              {t.footer.tagline}
            </p>
            <div className="flex items-center gap-2 mt-4">
              <MapPin className="w-4 h-4 text-[#FF3B30]" />
              <span className="text-xs text-[#A3A3A3] font-body">
                {t.footer.location}
              </span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-sm uppercase tracking-[0.2em] text-white mb-4">
              Links
            </h4>
            <div className="space-y-3">
              {[
                ["about", t.nav.programs],
                ["team", t.nav.team],
                ["forms", t.nav.contact],
              ].map(([id, label]) => (
                <button
                  key={id}
                  onClick={() => scrollTo(id)}
                  className="block text-sm text-[#A3A3A3] hover:text-[#FF3B30] transition-colors font-body"
                >
                  {label}
                </button>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-sm uppercase tracking-[0.2em] text-white mb-4">
              Contact
            </h4>
            <p className="text-sm text-[#A3A3A3] font-body">
              lnmtbacademy@gmail.com
            </p>
            <p className="text-sm text-[#A3A3A3] font-body mt-1">
              Camilo Cano Sports City
            </p>
            <p className="text-sm text-[#A3A3A3] font-body">
              La Nucia, 03530 Alicante, Spain
            </p>
          </div>
        </div>

        {/* Map */}
        <div className="mt-12 border border-[#262626] overflow-hidden">
          <iframe
            title="LNMA Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12548.42!2d-0.1303!3d38.6097!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd6209f20dd40d73%3A0x40d26b73e1a7480!2sLa%20Nucia%2C%20Alicante%2C%20Spain!5e0!3m2!1sen!2s!4v1"
            width="100%"
            height="250"
            style={{ border: 0, filter: "invert(90%) hue-rotate(180deg) brightness(0.8) contrast(1.2)" }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            data-testid="footer-map"
          />
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-8 border-t border-[#262626] flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-[#555] font-body">
            &copy; {new Date().getFullYear()} La Nucia MTB Academy. {t.footer.rights}
          </p>
        </div>
      </div>
    </footer>
  );
}
